module.exports = __webpack_public_path__ + "static/media/logo.f10ed06e.jpg";